import { render } from "./PaperUpload.vue?vue&type=template&id=4ed45eca&scoped=true"
import script from "./PaperUpload.vue?vue&type=script&lang=js"
export * from "./PaperUpload.vue?vue&type=script&lang=js"

import "./PaperUpload.vue?vue&type=style&index=0&id=4ed45eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed45eca"]])

export default __exports__